import SpecialistReportAPI from "api/SpecialistReportAPI";
import useFetchData from "hooks/useFetchData";

export default function useSpecialistReports( params: SpecialistReportsGETPaginatedParams = {}) {
   return useFetchData({
      APIMethod: SpecialistReportAPI.getAll,
      params: [ params ],
      debounce: true,
      clear_data_on_update: true
   })
}